/** @type {Record<string, string>} */
const tipClassPositions = {
  top: 'top',
  bottom: 'bottom',
  left: 'start',
  right: 'end',
};

export default tipClassPositions;
